import React from 'react'

const Beauty = () => {
  return (
    <div>Beauty</div>
  )
}

export default Beauty